<template>
  <div id="ht-wrap">
    <div id="options-wrap">
      <div class="options-box fl">
        <span class="select-name">区域：</span>
        <el-select
            v-model="division_checked"
            placeholder="请选择"
            size="small"
            @change="getTransformmerroom"
        >
          <el-option
              v-for="item in division"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="options-box fl">
        <span class="select-name">配电室：</span>
        <el-select
            v-model="transformerroom_checked"
            placeholder="请选择"
            size="small"
            @change="getDevice"
        >
          <el-option
              v-for="item in transformerroom"
              :key="item.place_unique_id"
              :label="item.name"
              :value="item.place_unique_id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="options-box fl">
        <span class="select-name">变压器/线路：</span>
        <el-select
            v-model="device_checked"
            placeholder="请选择"
            size="small"
            @change="getTableData"
        >
          <el-option
              v-for="item in device"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="options-box fl">
        <el-button size="small" @click="queryData">查询</el-button>
      </div>
      <div class="instruction-box">
        <!--        <div class="tag1 tags fl">-->
        <!--          <div class="tag-color"></div>-->
        <!--          <span class="tag-name">合闸</span>-->
        <!--        </div>-->
        <!--        <div class="tag2 tags fl">-->
        <!--          <div class="tag-color"></div>-->
        <!--          <span class="tag-name">分闸</span>-->
        <!--        </div>-->
        <div class="tag3 tags fl">
          <div class="tag-color"></div>
          <span class="tag-name">数值正常</span>
        </div>
        <div class="tag4 tags fl">
          <div class="tag-color"></div>
          <span class="tag-name">数值报警</span>
        </div>
      </div>
      <div class="jump-box" v-if="jumpBtn">
        <el-button size="small" @click="jumpPage">{{ transformerroom_name }}</el-button>
      </div>
    </div>
    <div style="display: flex;justify-content: center;">
      <div/>
      <div id="line-wrap"  class="media1">
      </div>
    </div>
  </div>
</template>

<script>
import {getSession} from "../../assets/js/tools/instruments";

export default {
  name: "eleRealTimeMonitoring",
  data() {
    return {
      dataModel: null,          //数据容器
      graphView: null,           //2D
      dm: null,
      division: '',
      transformerroom: '',
      device: '',
      division_checked: '',
      transformerroom_checked: '',
      transformerroom_name: '三维总配电室',
      device_checked: '',
      index_params: [0, 0, 0],
      realtime_params: [0, 0, 0],
      timer: null,
      table_data: '',
      tag1: [],
      tag2: [],
      table1_data: {},
      table2_data: {},
      initialization_data: '',
      jumpBtn: false,
      todayEpData: {},
      screenWidth: document.body.clientWidth
    }
  },
  beforeCreate() {
    window.htUrl('eleMonitor');
  },
  watch: {
    screenWidth(val) {
      this.reload(val);
    }
  },
  mounted() {
    this.addGraphView();
    let _this = this;
    this.timer = setInterval(function () {
      _this.updateTableData();
    }, 3000);
    const that = this;
    setTimeout(() => {
      this.reload(this.screenWidth)
    }, 30)
    window.onresize = () => (() => {
      window.screenWidth = document.body.clientWidth;
      that.screenWidth = window.screenWidth;
    })();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    reload(screewidth) {
      if (screewidth > 1660) {
        this.dm.getDataByTag("div").setScale(1, 1)
        this.dm.getDataByTag("div").p(788, 1026)
      } else if (screewidth >= 1525 && 1660 > screewidth) {
        this.dm.getDataByTag("div").setScale(0.9, 0.9)
        this.dm.getDataByTag("div").p(730, 950)
      } else if (screewidth >= 1405 && 1525 > screewidth) {
        this.dm.getDataByTag("div").setScale(0.8, 0.8)
        this.dm.getDataByTag("div").p(670, 870)
      } else if (screewidth >= 1270 && 1405 > screewidth) {
        this.dm.getDataByTag("div").setScale(0.7, 0.7)
        this.dm.getDataByTag("div").p(620, 750)
      } else if (screewidth >= 1140 && 1270 > screewidth) {
        this.dm.getDataByTag("div").setScale(0.6, 0.6)
        this.dm.getDataByTag("div").p(570, 650)
      } else if (screewidth >= 1000 && 1140 > screewidth) {
        this.dm.getDataByTag("div").setScale(0.5, 0.5)
        this.dm.getDataByTag("div").p(500, 550)
      } else if (screewidth >= 850 && 1000 > screewidth) {
        this.dm.getDataByTag("div").setScale(0.4, 0.4)
        this.dm.getDataByTag("div").p(430, 450)
      } else if (screewidth >= 650 && 850 > screewidth) {
        this.dm.getDataByTag("div").setScale(0.3, 0.3)
        this.dm.getDataByTag("div").p(350, 350)
      } else {
        this.dm.getDataByTag("div").setScale(0.3, 0.3)
        this.dm.getDataByTag("div").p(300, 300)
      }
    },
    judgeBtn() {
      let temp = JSON.parse(getSession('menuList'));
      for (let i in temp) {
        if (temp[i].url == 'powerdistributionmanagement') {
          let nodes = temp[i].nodes;
          for (let j in nodes) {
            if (nodes[j].url == 'elerealtimemonitoring') {
              nodes[j].nodes.length != 0 ? this.jumpBtn = true : this.jumpBtn = false;
            }
          }
        }
      }
    },
    addGraphView() {
      this.dataModel = new ht.DataModel();  // 数据容器
      this.graphView = new ht.graph.GraphView(this.dataModel); // 2d 绑定数据模型
      this.dm = this.graphView.dm();
      var _this = this;
      this.graphView.addToDOM(document.getElementById('line-wrap'));
      this.graphView.deserialize('displays/电力/electric.json', function () {
        _this.initTableData()
      })
    },
    // 初始化页面
    initTableData() {
      this.$get('elerealtimemonitoring/index', this.index_params)
          .then((response) => {
            this.division = response.division;
            this.transformerroom = response.transformerroom;
            this.device = response.device;
            this.division_checked = response.divisionChecked.id;
            this.transformerroom_checked = response.transformerroomChecked ? response.transformerroomChecked.place_unique_id : '';
            this.device_checked = response.deviceChecked ? response.deviceChecked.id : '';
            this.realtime_params = [this.division_checked, this.transformerroom_checked, this.device_checked]
            let initialization_data = response.initializationdata.electricMeterInfo;
            let transformer_data = response.initializationdata.transformerInformation;
            this.updateBoxData(transformer_data)
            if (this.transformerroom_checked === '01010001') {
              this.handleTableData1(initialization_data)
            } else if (this.transformerroom_checked === '01010002') {
              this.handleTableData2(initialization_data)
            }
            this.judgeBtn();
          })
          .catch((response) => {
            console.log(response);
          })
    },
    queryData() {
      let electric = this.dm.getDataByTag('electric');
      let electric2 = this.dm.getDataByTag('electric2');
      if (this.transformerroom_checked === '01010001') {
        this.transformerroom_name = '三维总配电室';
        electric.s('2d.visible', true);
        electric2.s('2d.visible', false);
      } else if (this.transformerroom_checked === '01010002') {
        this.transformerroom_name = '三维电子楼配电室';
        electric.s('2d.visible', false);
        electric2.s('2d.visible', true);
      }
    },
    jumpPage() {
      if (this.transformerroom_checked === '01010001') {
        this.$router.push('/eleDistributionRoom');
      } else if (this.transformerroom_checked === '01010002') {
        this.$router.push('/eleDistributionRoom1');
      }
    },
    // 实时刷新表格数据
    updateTableData() {
      if (this.$route.path != '/eleRealTimeMonitoring') {
        return
      }
      if (this.transformerroom_checked !== '' && this.device_checked !== '') {
        this.$get('elerealtimemonitoring/realtimedata', this.realtime_params)
            .then((response) => {
              let initialization_data = response.electricMeterInfo;
              let transformer_data = response.transformerInformation;
              if (initialization_data.hasOwnProperty('TG232:a1_b1')) {
                this.handleTableData1(initialization_data)
              } else {
                this.handleTableData2(initialization_data)
              }
              this.updateBoxData(transformer_data)
            })
            .catch((response) => {
              console.log(response);
            })
      }
    },
    // 实时刷新变压器数据
    updateBoxData(transformer_data) {
      let transformer1_Ta = this.dm.getDataByTag('transformer1-Ta');
      let transformer1_Tb = this.dm.getDataByTag('transformer1-Tb');
      let transformer1_Tc = this.dm.getDataByTag('transformer1-Tc');
      let transformer1_pf = this.dm.getDataByTag('transformer1-pf');
      let transformer2_Ta = this.dm.getDataByTag('transformer2-Ta');
      let transformer2_Tb = this.dm.getDataByTag('transformer2-Tb');
      let transformer2_Tc = this.dm.getDataByTag('transformer2-Tc');
      let transformer2_pf = this.dm.getDataByTag('transformer2-pf');
      transformer_data.forEach(function (item, index) {
        let temperature_key = item.temperatureKey;
        let voltage_key = item.lowVoltageIncomingLinekey;
        if (index === 0) {
          transformer1_Ta.a('value', item[temperature_key].ta)
          transformer1_Tb.a('value', item[temperature_key].tb)
          transformer1_Tc.a('value', item[temperature_key].tc)
          transformer1_pf.a('value', item[voltage_key].pf)
        } else if (index === 1) {
          transformer2_Ta.a('value', item[temperature_key].ta)
          transformer2_Tb.a('value', item[temperature_key].tb)
          transformer2_Tc.a('value', item[temperature_key].tc)
          transformer2_pf.a('value', item[voltage_key].pf)
        }
      })
      transformer1_Ta.a('name', 'Ta')
      transformer1_Tb.a('name', 'Tb')
      transformer1_Tc.a('name', 'Tc')
      transformer1_pf.a('name', 'pf')
      transformer2_Ta.a('name', 'Ta')
      transformer2_Tb.a('name', 'Tb')
      transformer2_Tc.a('name', 'Tc')
      transformer2_pf.a('name', 'pf')
    },
    getTransformmerroom() {
      this.index_params[0] = this.division_checked
      this.index_params[1] = 0
      this.index_params[2] = 0
      this.initTableData()
    },
    getDevice() {
      this.index_params[1] = this.transformerroom_checked
      this.index_params[2] = 0
      this.initTableData()
    },
    getTableData() {
      this.index_params[2] = this.device_checked
      this.initTableData()
    },
    // 处理后端传入的表格数据
    handleTableData1(data) {
      let table1 = this.dm.getDataByTag('table1-1');
      let table2 = this.dm.getDataByTag('table1-2');
      let table3 = this.dm.getDataByTag('table1-3');
      this.judgeDataChange(data, this.tag1, 'table1_data');
      table1.a('ht.dataSource', this.table_data);
      table2.a('ht.dataSource', this.table_data);
      table3.a('ht.dataSource', this.table_data);
    },
    handleTableData2(data) {
      let table1 = this.dm.getDataByTag('table2-1');
      let table2 = this.dm.getDataByTag('table2-2');
      this.judgeDataChange(data, this.tag2, 'table2_data');
      table1.a('ht.dataSource', this.table_data);
      table2.a('ht.dataSource', this.table_data);
    },
    // 判断数据变化并整理数据格式
    judgeDataChange(data0, tags, data) {
      let table_data = [];
      let obj_uab = {
        tag: 'Uab(V)'
      }
      let obj_ubc = {
        tag: 'Ubc(V)'
      }
      let obj_uca = {
        tag: 'Uca(V)'
      }
      let obj_ia = {
        tag: 'Ia(A)'
      }
      let obj_ib = {
        tag: 'Ib(A)'
      }
      let obj_ic = {
        tag: 'Ic(A)'
      }
      let obj_ep = {
        tag: 'Ep(kW·h)'
      }
      let obj_todayEp = {
        tag: '日能耗(kW·h)'
      }
      let obj_p = {
        tag: 'P(kW)'
      }
      let obj_q = {
        tag: 'Q(kVar)'
      }
      let obj_di = {}
      tags.length = 0;
      for (let i in data0) {
        let device_data = data0[i],
            tag = i.substring(6);
        tags.push(tag);
        for (let j in device_data) {
          if (j === 'uab') {
            obj_uab[tag] = data0[i].uab
          } else if (j === 'ubc') {
            obj_ubc[tag] = data0[i].ubc
          } else if (j === 'uca') {
            obj_uca[tag] = data0[i].uca
          } else if (j === 'ia') {
            obj_ia[tag] = data0[i].ia
          } else if (j === 'ib') {
            obj_ib[tag] = data0[i].ib
          } else if (j === 'ic') {
            obj_ic[tag] = data0[i].ic
          } else if (j === 'ep') {
            obj_ep[tag] = data0[i].ep
          } else if (j === 'p') {
            obj_p[tag] = data0[i].p
          } else if (j === 'q') {
            obj_q[tag] = data0[i].q
          } else if (j === 'todayEp') {
            obj_todayEp[tag] = data0[i].todayEp
            this.todayEpData[tag] = data0[i].todayEp
          } else if (j === 'di') {
            obj_di[tag] = data0[i].di
            obj_todayEp[tag] = this.todayEpData[tag]
          }
        }
      }
      for (let k in obj_di) {
        let model = this.dm.getDataByTag(k)
        if (obj_di[k]) {
          model.a('switch', 0)
        } else {
          model.a('switch', -Math.PI / 6)
        }
      }
      tags.forEach((item, index) => {
        let isChange = 'isChange' + index
        if (Object.keys(this[data]).length === 0) {
          obj_uab[isChange] = false
          obj_ubc[isChange] = false
          obj_uca[isChange] = false
          obj_ia[isChange] = false
          obj_ib[isChange] = false
          obj_ic[isChange] = false
          obj_ep[isChange] = false
          obj_todayEp[isChange] = false
          obj_p[isChange] = false
          obj_q[isChange] = false
        } else {
          if (obj_uab[item] !== this[data].obj_uab[item]) {
            obj_uab[isChange] = true
          } else {
            obj_uab[isChange] = false
          }
          if (obj_ubc[item] !== this[data].obj_ubc[item]) {
            obj_ubc[isChange] = true
          } else {
            obj_ubc[isChange] = false
          }
          if (obj_uca[item] !== this[data].obj_uca[item]) {
            obj_uca[isChange] = true
          } else {
            obj_uca[isChange] = false
          }
          if (obj_ia[item] !== this[data].obj_ia[item]) {
            obj_ia[isChange] = true
          } else {
            obj_ia[isChange] = false
          }
          if (obj_ib[item] !== this[data].obj_ib[item]) {
            obj_ib[isChange] = true
          } else {
            obj_ib[isChange] = false
          }
          if (obj_ic[item] !== this[data].obj_ic[item]) {
            obj_ic[isChange] = true
          } else {
            obj_ic[isChange] = false
          }
          if (obj_ep[item] !== this[data].obj_ep[item]) {
            obj_ep[isChange] = true
          } else {
            obj_ep[isChange] = false
          }
          if (obj_todayEp[item] !== this[data].obj_todayEp[item]) {
            obj_todayEp[isChange] = true
          } else {
            obj_todayEp[isChange] = false
          }
          if (obj_p[item] !== this[data].obj_p[item]) {
            obj_p[isChange] = true
          } else {
            obj_p[isChange] = false
          }
          if (obj_q[item] !== this[data].obj_q[item]) {
            obj_q[isChange] = true
          } else {
            obj_q[isChange] = false
          }
        }
      })
      this[data] = {
        obj_uab,
        obj_ubc,
        obj_uca,
        obj_ia,
        obj_ib,
        obj_ic,
        obj_ep,
        obj_todayEp,
        obj_p,
        obj_q
      }
      table_data.push(obj_uab, obj_ubc, obj_uca, obj_ia, obj_ib, obj_ic, obj_ep, obj_todayEp, obj_p, obj_q)
      this.table_data = table_data
    }
  }
}
</script>
<style scoped lang="scss">
#ht-wrap {
  width: 100%;
  height: 450px;
  display: table;
  .media1{
      width: 90% ;
    }
    @media screen and (width:3440px) and (height: 1440px )   {
      .media1{
      width: 50% ;
    }
    }
    @media screen and (width:3840px) and (height: 1080px )   {
      .media1{
      width: 50% ;
    }
    }
  #options-wrap {
    width: 90%;
    color: #fff;
    display: table;
    position: relative;
    margin-left: 80px;
    margin-top: 30px;
    margin-bottom: 20px;

    .options-box {
      margin: 10px;
      display: table;

      .el-radio-button {
        margin-right: 10px;
      }
    }

    .instruction-box {
      position: absolute;
      top: 20px;
      right: 40px;

      .tags {
        margin-right: 15px;

        .tag-color {
          margin-right: 5px;
          display: inline-block;
          vertical-align: bottom;
        }
      }

      //.tag1 {
      //  .tag-color {
      //    width: 10px;
      //    height: 15px;
      //    background-color: red;
      //  }
      //}
      //.tag2 {
      //  .tag-color {
      //    width: 10px;
      //    height: 15px;
      //    background-color: green;
      //  }
      //}
      .tag3 {
        .tag-color {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background-color: green;
        }
      }

      .tag4 {
        .tag-color {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background-color: red;
        }
      }
    }

    .jump-box {
      position: absolute;
      top: 13px;
      right: -71px;

      .el-button {
        padding: 9px 10px;
      }
    }
  }

  #line-wrap {
    position: relative;
    height: 650px;
  }
  @media screen and (width:3440px) and (height: 1440px )   {
    #line-wrap {
    height: 1000px;
  }
    }
}
</style>
